export const LOAD_CATEGORIES = 'containers/CategoriesPage/LOAD_CATEGORIES';
export const LOAD_CATEGORIES_SUCCESS = 'containers/CategoriesPage/LOAD_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_ERROR = 'containers/CategoriesPage/LOAD_CATEGORIES_ERROR';
